import { gql, TypedDocumentNode } from '@apollo/client';
import { FormTemplateData, GetFormTemplateDataInput } from './schema';
import { Profile } from '../../Types';
import { ContactStatus } from '../../PerformancePortal/Dashboard/DashboardComponents/HmdDetails/types';
import { GetContactStatusVariables } from '../Naws';
import { ConsolidatedContact } from '../CoachingNotes/schema';

export const GET_FORM_TEMPLATE_DATA: TypedDocumentNode<
  { getFormTemplates: FormTemplateData[] },
  GetFormTemplateDataInput
> = gql`
  query GetFormTemplates(
    $FORM_ID: String
    $VERSION: String
    $VERTICAL: String
  ) {
    getFormTemplates(
      FORM_ID: $FORM_ID
      VERSION: $VERSION
      VERTICAL: $VERTICAL
    ) {
      FORM_ID
      VERSION
      TITLE {
        TRANSLATION_ID
        DEFAULT_MESSAGE
      }
      SECTIONS {
        SECTION_ID
        TYPE
        QUESTION_TEXT {
          TRANSLATION_ID
          DEFAULT_MESSAGE
        }
        QUESTIONS {
          QUESTION_ID
          QUESTION_TEXT {
            TRANSLATION_ID
            DEFAULT_MESSAGE
          }
          QUESTION_OPTIONS {
            TRANSLATION_ID
            DEFAULT_MESSAGE
            VALUE
          }
          DEFAULT_SELECTED {
            DEFAULT_MESSAGE
          }
        }
      }
      EXTRA {
        DEFAULT_MESSAGE
        TRANSLATION_ID
      }
      AUTOFILL {
        QUESTION_ID
        TS_KEY
      }
    }
  }
`;

// Profile data query
export const GET_PROFILE_DATA: TypedDocumentNode<
  { getProfileData: Profile },
  { userID: string; week: string; cscEntityPrefix: string }
> = gql`
  query GetProfileData(
    $userID: String!
    $week: String!
    $cscEntityPrefix: String!
  ) {
    getProfileData(
      userID: $userID
      week: $week
      cscEntityPrefix: $cscEntityPrefix
    ) {
      user {
        userID
        userName
        displayName
        alias
      }
    }
  }
`;

// Contact status query
export const GET_CONTACT_STATUS: TypedDocumentNode<
  { getContactStatus: ContactStatus },
  GetContactStatusVariables
> = gql`
  query GetContactStatus($userID: String!, $dateRange: DateRange!) {
    getContactStatus(userID: $userID, dateRange: $dateRange) {
      totalContacts
      reviewedContacts
      pendingContacts
    }
  }
`;

export const GET_CONSOLIDATED_CONTACTS: TypedDocumentNode<
  { getConsolidatedContacts: ConsolidatedContact[] },
  {
    userID: string;
    userName: string;
    startWeek: number;
    startYear: number;
    endWeek: number;
    endYear: number;
  }
> = gql`
  query GetConsolidatedContacts(
    $userID: String!
    $userName: String!
    $startWeek: Int!
    $startYear: Int!
    $endWeek: Int!
    $endYear: Int!
  ) {
    getConsolidatedContacts(
      userID: $userID
      userName: $userName
      startWeek: $startWeek
      startYear: $startYear
      endWeek: $endWeek
      endYear: $endYear
    ) {
      contactID
      userID
      marketplaceID
      marketplaceDomainName
      status
      calYear
      calWeek
      contactDate
      sic
      skill
      channel
      ownership
      duration
      category
      displayOrder
      deliverInfo {
        deliverStatus
        deliverDate
        noteID
      }
      contactInfo {
        goodRecommendation
        uncoachableReason
        relatedMetric
      }
      recommended
      recent
      saved
      saveOrigin
      contactStatus
      processName
      formReviews {
        formID
        version
        formAnswer {
          questionID
          questionText {
            translationID
            defaultMessage
          }
          selectedOption {
            translationID
            defaultMessage
          }
          answerText
          value
        }
      }
    }
  }
`;
